<template>
  <div class="CpfInput">
    <TextInput
      :id="$attrs.id || 'cpf'"
      v-bind="$attrs"
      :class="$attrs.class || 'field required'"
      :name="$attrs.name || 'cpf'"
      :label="$attrs.label || 'CPF'"
      :placeholder="$attrs.placeholder || '000.000.000-00'"
      :helper-size="11"
      mask="###.###.###-##"
      validations="required|cpf-length|cpf"
      @input="$emit('input', $event)"
    >
      <template #external-message>
        <slot name="external-message" />
      </template>
    </TextInput>
    <slot name="extraContent" />
  </div>
</template>
<script>
import TextInput from '@/components/ui/newComponents/TextInput.vue'
export default {
  name: 'CpfInput',
  components: {
    TextInput,
  },
  emits: ['input'],
}
</script>
<style lang="scss"></style>
